import { functions } from "../config"
import { httpsCallable } from "firebase/functions"
import { LOG_CATEGORY_CLIENT } from "../Constants/logsConstant";

export const clientLogEvent = async ({
  uid = null,
  type = null,
  category = null,
  message = null,
  source = null,
  page = typeof window !== "undefined" ? window.location.pathname : null,
  emailInfo = null,
  ip = null,
  metadata = {},
  error = null
}) => {
  const effectiveCategory = uid ? (category || LOG_CATEGORY_CLIENT.USER) : LOG_CATEGORY_CLIENT.UNAUTH;
  const payload = {
    uid,
    type,
    category: effectiveCategory,
    message,
    source,
    page,
    emailInfo,
    ip,
    metadata: metadata || null,
    error
  }

  try {
    const logger = httpsCallable(functions, "logger")
    const response = await logger(payload)
    if (response.isSuccess) {
      return response.data
    } else {
      return null
    }
  } catch (err) {
    return null
  }
}